import { TimeEntry } from './time-entry.model';

export class AppointmentTimeEntry {
	apptId = -2000; // Magic number for 'Other'
	apptStart = '0001-01-01T00:00:00-05:00';
	displayValue = 'Other';
	techId: number;
	entries = [] as TimeEntry[];

	constructor(init?: Partial<AppointmentTimeEntry>) {
		Object.assign(this, init);
	}
}
